import React, { ReactNode, useEffect, useState } from 'react';

interface DashboardProviderProps {
  children: ReactNode;
  urlString: URLSearchParams;
}

type DashboardContextValue = [
  URLSearchParams,
  React.Dispatch<React.SetStateAction<URLSearchParams>>
];

const DashboardContext = React.createContext<DashboardContextValue>([
  new URLSearchParams(),
  (): null => null
] as DashboardContextValue);
export const useDashboard = (): DashboardContextValue => React.useContext(DashboardContext);

const DashboardProvider = ({ children, urlString }: DashboardProviderProps): JSX.Element => {
  const [queryString, setQueryString] = useState<URLSearchParams>(urlString);

  useEffect(() => {
    const initData = async (): Promise<void> => {
      setQueryString(urlString);
    };
    initData();
  }, [urlString]);

  return (
    <DashboardContext.Provider value={[queryString, setQueryString]}>
      {children}
    </DashboardContext.Provider>
  );
};

export default DashboardProvider;
